import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="M23 3a4 4 0 0 1 3.995 3.8L27 7v18a4 4 0 0 1-3.8 3.995L23 29H7a2 2 0 0 1-1.995-1.85L5 27v-2H4a1 1 0 0 1-.117-1.993L4 23h1v-3H4a1 1 0 0 1-.117-1.993L4 18h1v-3H4a1 1 0 0 1-.117-1.993L4 13h1v-3H4a1 1 0 0 1-.117-1.993L4 8h1V5a2 2 0 0 1 1.85-1.995L7 3zm0 2h-1v8a1 1 0 0 1-1.458.89l-.097-.058L18 12.202l-2.445 1.63a1 1 0 0 1-1.55-.72L14 13V5H7v3h1a1 1 0 0 1 .117 1.993L8 10H7v3h1a1 1 0 0 1 .117 1.993L8 15H7v3h1a1 1 0 0 1 .117 1.993L8 20H7v3h1a1 1 0 0 1 .117 1.993L8 25H7v2h16a2 2 0 0 0 1.994-1.85L25 25V7a2 2 0 0 0-1.85-1.995zm-3 0h-4v6.13l1.445-.962a1 1 0 0 1 .994-.066l.116.066L20 11.13z"
    />
  </svg>
);
const SvgIconDailyLogs = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconDailyLogs);
export default Memo;
